import React from "react";
import { Select } from "../../../../../../shared/infrastructure/ui";
import { SelectComponentProps } from "./types";
import { useInfiniteGetDispatchers } from "../../../services";
import { withSelectOptions } from "./with-select-options";
import {
  DispatcherT,
  UseGetDispatcherFilters,
} from "../../../../domain/entities";

const RenderOption = ({ dispatcher }: DispatcherT): React.ReactElement => {
  return (
    <section className="grid w-[300px] grid-flow-col items-center justify-between px-[5px] text-[12px] capitalize">
      <span>{dispatcher?.toLowerCase() ?? "- -"}</span>
    </section>
  );
};

const DispatcherSelectComponent = ({
  placeholder,
  name = "",
  selectedValue,
  onChangeValue,
  error = "",
  variant = "standard",
  disabled = false,
  handleSetKeyword,
  isLoading,
  getNextPage,
  noMore,
  data,
  noError,
  labelProp = "dispatcher",
  keyword,
  multiselect,
}: SelectComponentProps<DispatcherT>): React.ReactElement => {
  return (
    <Select<DispatcherT>
      searchValue={keyword}
      multiselect={multiselect}
      disabled={disabled}
      loading={isLoading}
      placeholder={placeholder}
      options={data}
      name={name}
      asyncFilter={handleSetKeyword}
      labelProp={labelProp}
      value={selectedValue}
      onChange={onChangeValue}
      noMore={noMore}
      getMore={getNextPage}
      renderOptionComponent={RenderOption}
      error={error}
      variant={variant}
      noError={noError}
    />
  );
};

export const DispatcherSelect = withSelectOptions<
  DispatcherT,
  UseGetDispatcherFilters
>(DispatcherSelectComponent, useInfiniteGetDispatchers, "dispatcher");
